import type { StaffNotification } from '@/types/notifications';

export const INTERNAL_MESSAGE_NOTIFICATION_TYPE = 'internal_message.received';

export function shouldOpenNotificationGroup(
  target: Pick<StaffNotification, 'type' | 'groupCount' | 'groupKey'>,
): boolean {
  return (
    target.type !== INTERNAL_MESSAGE_NOTIFICATION_TYPE &&
    target.groupCount > 1 &&
    target.groupKey !== null
  );
}

/**
 * Where a notification should take you. Team chat notifications carry an
 * actionUrl, but an entity-only payload (older rows, deduped groups) still
 * names its conversation, so it can open the chat instead of doing nothing.
 */
export function notificationActionUrl(
  target: Pick<StaffNotification, 'type' | 'actionUrl' | 'entityType' | 'entityId'>,
): string | null {
  if (target.actionUrl) return target.actionUrl;
  if (
    target.type === INTERNAL_MESSAGE_NOTIFICATION_TYPE &&
    target.entityType === 'InternalConversation' &&
    target.entityId
  ) {
    return `/dashboard/team-chat?conversationId=${encodeURIComponent(target.entityId)}`;
  }
  return null;
}
